import React, { useSyncExternalStore } from 'react';
import { AnimatePresence } from 'framer-motion';
import { subscribeToasts, getToastsSnapshot } from '../../services/toastStore';
import Toast from './Toast';

/**
 * Mounted once, at the app root (see App.tsx) -- the visual half of the
 * app's unified toast system. Reads the module-level store via
 * useSyncExternalStore rather than a Context provider, since toasts are
 * pushed from plain service/helper code as often as from components (same
 * reason antd's own `message` API needed no provider either).
 *
 * `layout` on each Toast plus this AnimatePresence is what makes the stack
 * re-flow with a transition when one closes, instead of the rest jumping
 * up instantly.
 */
const ToastContainer: React.FC = () => {
  const toasts = useSyncExternalStore(subscribeToasts, getToastsSnapshot);

  if (toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 24,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 14,
        zIndex: 2000,
        pointerEvents: 'none',
      }}
    >
      <AnimatePresence>
        {toasts.map((toast) => (
          <Toast key={toast.id} toast={toast} />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default ToastContainer;
